import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface NavigableEventArgs {
  abort: Function;
  from: any;
  to?: any;
}

class NavigableEvent<T> extends EventData<Navigable<T>> implements NavigableEventArgs {

  abort: Function;
  from: T;
  to?: T;

  constructor({ abort, from, to }: NavigableEventArgs) {
    super();

    this.abort = abort;
    this.from = from;
    this.to = to;
  }
}

class NavigableEventListener<T> extends EventListener<Navigable<T>, NavigableEvent<T>, NavigableEventArgs> {
  constructor() {
    super(NavigableEvent);
  }
}

export default interface Navigable<T> extends Mountable {

  /** @event */
  onAfterNavigate: NavigableEventListener<T>;

  /** @event */
  onNavigate: NavigableEventListener<T>;

}

export { NavigableEventListener, NavigableEvent };
